import type { LucideIcon, LucideProps } from 'lucide-react';
import type { RefAttributes } from 'react';
import { cn } from '../lib/utils';

export type IconProps = Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>;

export function createIcon(LucideComponent: LucideIcon, displayName: string) {
  function Icon({ className, ...props }: IconProps) {
    return <LucideComponent className={cn('size-icon-sm', className)} {...props} />;
  }
  Icon.displayName = displayName;
  return Icon;
}
